import { render, staticRenderFns } from "./filter-bar-item.vue?vue&type=template&id=54e87fe1"
import script from "./filter-bar-item.vue?vue&type=script&lang=js"
export * from "./filter-bar-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports